import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)


const defaultUser = {
  username: "אורח",
  image: "https://img.favpng.com/25/13/19/samsung-galaxy-a8-a8-user-login-telephone-avatar-png-favpng-dqKEPfX7hPbc6SMVUCteANKwj.jpg"
}

const defaultUserSettings = {
  id: null,
  informationViewed: true
}

export default new Vuex.Store({
  state: {
    user: null,
    permissions: null,
    userSettings: defaultUserSettings,
    isDarkMode: false,
    intro: true,
    pupils: null,
    gradeOptions: null,
    teachers: null,
    subjectLesson: null,
    reportRanges: null,
    reportRatings: null,
    subjectTracing: null,
    presenceStatus: null,
    lessonTime: null,
    isStateReady: false

  },
  // getters:{
  //   getPupil:() => {
  //     return state.pupils
  //   }
  // },

  mutations: {
    isStateReady(state){
      if (state.pupils !== null &&
          state.gradeOptions !== null &&
          state.subjectLesson !== null &&
          state.subjectTracing !== null &&
          state.presenceStatus !== null &&
          state.teachers !== null &&
          state.lessonTime !== null
          // state.user !== null
      ){
        state.isStateReady = true
      }
    },
    setUser(state, user) {
      state.user = user;
      if (state.user !== null) {
        if (state.user.image == null) {
          state.user.image = "https://futureu.europa.eu/decidim-packs/media/images/default-avatar-aaa9e55bac5d7159b847.svg"
        }
      }
    },

    setUserSettings(state, settings) {
      state.userSettings = settings
    },

    setPermissions(state, permissions) {
      state.permissions = permissions
    },

    setDefaultUser(state) {
      // state.user = defaultUser
    },

    changeMode(state) {
      state.isDarkMode = !state.isDarkMode;
    },

    setPupils(state, options) {
      state.pupils = options
    },

    setTeachers(state, options) {
      state.teachers = options
    },

    setGradeOptions(state, options) {
      state.gradeOptions = options
    },

    setPresenceStatus(state, options) {
      state.presenceStatus = options
    },

    setSubjectLesson(state, options) {
      state.subjectLesson = options
    },

    setSubjectTracing(state, options) {
      state.subjectTracing = options
    },

    setLessonTime(state, options) {
      state.lessonTime = options
    },

    setReportRanges(state, options) {
      state.reportRanges = options
    },

    setReportRatings(state, options) {
      state.reportRatings = options
    },


    disableIntro(state) {
      state.intro = false
    },
    stateNotReady(){
      this.state.isStateReady = false
    }
  },

  actions: {
    stateNotReady({ commit }){
      commit("stateNotReady")
    },
    setUserSettings({ commit }, settings) {
      commit("setUserSettings");
      commit("setUserSettings", settings);
    },

    setUser({ commit }, userr) {
      commit("setUser", userr);
    },

    setPermissions({ commit }, permissions) {
      commit("setPermissions", permissions);
    },

    setPupils({ commit }, options) {
      commit("setPupils", options);
      commit("isStateReady");
    },

    setTeachers({ commit }, options) {
      commit("setTeachers", options);
      commit("isStateReady");
    },

    setGradeOptions({ commit }, options) {
      commit("setGradeOptions", options);
      commit("isStateReady");

    },
    setPresenceStatus({ commit }, options) {
      commit("setPresenceStatus", options);
      commit("isStateReady");

    },
    setSubjectLesson({ commit }, options) {
      commit("setSubjectLesson", options);
      commit("isStateReady");
    },
    setSubjectTracing({ commit }, options) {
      commit("setSubjectTracing", options);
      commit("isStateReady");
    },

    setLessonTime({ commit }, options) {
      commit("setLessonTime", options);
      commit("isStateReady");
    },

    setReportRanges({ commit }, options) {
      commit("setReportRanges", options);
    },

    setReportRatings({ commit }, options) {
      commit("setReportRatings", options);
    },

    changeMode({ commit }) {
      commit("changeMode");
    },

    disableIntro({ commit }) {
      commit("disableIntro");
    }
  }
})
